import { SystemStateMessageTypes } from './SystemStateMessageTypes';
/**
 * システム状態表示メッセージ
 */
export class SystemStateMessage {
  type: SystemStateMessageTypes;
  message: string;
}


// WEBPACK FOOTER //
// ./src/models/SystemStateMessage.ts